<template>
    <form-row title="Is This Building LEED Certified?" :label_align_top="true">
        <div class="flex flex-col flex-1 pt-2">
            <input-radio-boolean
                name="is_leed_certified"
                v-model="is_leed_certified"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-radio-multi
                v-if="is_leed_certified"
                class="mt-4 flex-1"
                label="Certification Level"
                name="leed_certified_level"
                :value="property.leed_certified_level"
                :options="[
                    { value: 'certified', label: 'Certified' },
                    { value: 'silver', label: 'Silver' },
                    { value: 'gold', label: 'Gold' },
                    { value: 'platinum', label: 'Platinum' },
                ]"
                :nullable="true"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            is_leed_certified: this.property.is_leed_certified ? true : false,
        }
    },
}
</script>
